"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es7.symbol.async-iterator");
require("core-js/modules/es6.symbol");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.array.from");
require("core-js/modules/es6.regexp.to-string");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OPERATION_SOURCE_PC = exports.OPERATION_ID_WHITELIST = void 0;
exports.batchMarkOperationNotified = batchMarkOperationNotified;
exports.buildAdminOperationReportMeta = buildAdminOperationReportMeta;
exports.getOperationRouteContext = getOperationRouteContext;
exports.inferReportMetaFromRequest = inferReportMetaFromRequest;
exports.isInWhitelist = isInWhitelist;
exports.normalizeReportMetaOption = normalizeReportMetaOption;
exports.reportAdminOperation = reportAdminOperation;
exports.setAdminOperationRouter = setAdminOperationRouter;
exports.triggerAdminOperationReportAfterSuccess = triggerAdminOperationReportAfterSuccess;
exports.withAdminOperationReport = withAdminOperationReport;
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
var _defineProperty2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _typeof2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/typeof.js"));
var _slicedToArray2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/slicedToArray.js"));
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _axios = _interopRequireDefault(require("axios"));
var _vue = _interopRequireDefault(require("vue"));
var _auth = require("@/utils/auth");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } /**
 * PC 管理端操作埋点上报（核心）
 * 实施时间：2026-05-25
 * 接口：POST agentapi/admin_operation/report
 * 说明：白名单校验、request 拦截器自动上报、buildAdminOperationReportMeta 构造第三参数
 */
/** PC 管理端固定为 2 */
var OPERATION_SOURCE_PC = exports.OPERATION_SOURCE_PC = 2;

// 上报HTTP接口
var REPORT_PATH = '/agentapi/admin_operation/report';
var _router = null;

/** 在 main.js 中注入，用于解析当前路由与面包屑菜单名 */
function setAdminOperationRouter(router) {
  _router = router;
}

/**
 * 【操作埋点】2026-05-25 埋点序号白名单
 * 格式: pc_模块_操作_序号；仅白名单内 operation_id 会实际上报
 */
var OPERATION_ID_WHITELIST = exports.OPERATION_ID_WHITELIST = [
// 代理商管理
'pc_agent_add_1', 'pc_agent_edit_1', 'pc_agent_delete_1', 'pc_agent_frozen_1', 'pc_agent_password_1', 'pc_agent_freez_money_1', 'pc_agent_withdraw_1', 'pc_agent_member_1', 'pc_agent_active_1', 'pc_agent_withdraw_fee_1', 'pc_agent_deposit_1', 'pc_agent_account_1', 'pc_agent_yezz_1', 'pc_agent_icon_1', 'pc_agent_login_1', 'pc_agent_distribute_1',
// 设备管理
'pc_equipment_distribute_1', 'pc_equipment_recover_1', 'pc_equipment_unbind_1', 'pc_equipment_room_no_1', 'pc_equipment_upgrade_1', 'pc_equipment_restart_1', 'pc_equipment_cost_1',
// 用户管理
'pc_user_member_1', 'pc_user_recharge_1', 'pc_user_refund_1', 'pc_user_black_1',
// 提现管理
'pc_withdraw_approve_1', 'pc_withdraw_reject_1', 'pc_withdraw_batch_1',
// 订单管理
'pc_order_finish_1', 'pc_order_refund_1', 'pc_order_steal_1',
// 商户管理
'pc_shop_add_1', 'pc_shop_edit_1', 'pc_shop_delete_1', 'pc_shop_steal_1', 'pc_shop_withdraw_fee_1', 'pc_shop_deposit_1', 'pc_shop_account_1', 'pc_shop_yezz_1', 'pc_shop_yj_1', 'pc_shop_commission_1', 'pc_shop_promoter_1', 'pc_shop_ad_1', 'pc_shop_night_1', 'pc_shop_shgs_1',
// 广告管理
'pc_ad_create_1', 'pc_ad_delete_1', 'pc_ad_bind_1', 'pc_ad_audit_1',
// 系统设置
'pc_setting_update_1',
// 权限管理
'pc_permission_menu_add_1', 'pc_permission_admin_add_1', 'pc_permission_role_set_1',
// 押金退还
'pc_withdraw_deposit_refund_1',
// 用户反馈
'pc_feedback_reply_1', 'pc_feedback_deal_1',
// 客户记录
'pc_customer_record_create_1', 'pc_customer_record_update_1', 'pc_customer_record_delete_1'];

/**
 * 检查埋点ID是否在白名单中
 */
function isInWhitelist(operationId) {
  if (!operationId) return false;
  return OPERATION_ID_WHITELIST.includes(operationId);
}

/** 不上报的请求（查询、登录、验证码、埋点自身等） */
var SKIP_URL_REGEXP = [/admin_operation\/report/i, /\/login\b/i, /check_captche/i, /check_password/i, /record_password/i, /insert_password/i, /edit_password_save/i, /password_updated/i, /pretend_son_login/i, /get_|\/get[A-Z]/i, /query_|search_/i, /my_user_info/i, /get_platform_config/i, /add_record$/i, /list$/i, /export/i];

/** 视为「增删改」的 URL 特征（POST 时） */
var MUTATION_URL_REGEXP = [/save_/i, /add_/i, /edit_/i, /delete_/i, /remove_/i, /update_/i, /set_/i, /create_/i, /insert_/i, /bind_/i, /distribute_/i, /frozen/i, /submit_/i, /save$/i, /postSetRecode/i, /record_/i, /steal_/i, /withdraw/i, /upload/i, /import/i, /cancel_/i, /restore_/i, /enable_/i, /disable_/i];
var ACTION_LABEL_MAP = [[/delete_/i, '删除'], [/remove_/i, '删除'], [/save_add_/i, '新增'], [/save_edit_/i, '编辑保存'], [/save_/i, '保存'], [/add_/i, '新增'], [/edit_/i, '编辑'], [/set_/i, '设置'], [/update_/i, '更新'], [/create_/i, '创建'], [/insert_/i, '创建'], [/bind_/i, '绑定'], [/distribute_/i, '分配']];
function shouldSkipReportUrl(url) {
  if (!url) return true;
  var path = String(url).split('?')[0];
  return SKIP_URL_REGEXP.some(function (re) {
    return re.test(path);
  });
}
function isMutationPostUrl(url) {
  if (!url) return false;
  var path = String(url).split('?')[0];
  if (shouldSkipReportUrl(path)) return false;
  return MUTATION_URL_REGEXP.some(function (re) {
    return re.test(path);
  });
}
function inferActionLabel(url) {
  var path = String(url).split('?')[0];
  var _iterator = _createForOfIteratorHelper(ACTION_LABEL_MAP),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = (0, _slicedToArray2.default)(_step.value, 2),
        re = _step$value[0],
        label = _step$value[1];
      if (re.test(path)) return label;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var seg = path.replace(/^.*agentapi\//, '').replace(/\//g, '_');
  return seg || '操作';
}
function inferOptionName(url, method) {
  var path = String(url).split('?')[0];
  var action = inferActionLabel(path);
  var apiTail = path.replace(/^.*agentapi\//, '') || path;
  if (method === 'delete') return "\u5220\u9664\uFF08".concat(apiTail, "\uFF09");
  if (method === 'put') return "\u66F4\u65B0\uFF08".concat(apiTail, "\uFF09");
  return "".concat(action, "\uFF08").concat(apiTail, "\uFF09");
}
function formatPayloadForContent(data) {
  if (data == null) return '';
  if (typeof data === 'string') {
    try {
      var parsed = JSON.parse(data);
      return formatPayloadForContent(parsed);
    } catch (e) {
      return data.length > 500 ? data.slice(0, 500) + '…' : data;
    }
  }
  if ((0, _typeof2.default)(data) !== 'object') return String(data);
  var clone = _objectSpread({}, data);
  delete clone.token;
  delete clone.user_id;
  delete clone.agent_id;
  var keys = Object.keys(clone);
  if (!keys.length) return '';
  var text = JSON.stringify(clone);
  return text.length > 800 ? text.slice(0, 800) + '…' : text;
}

/**
 * 与 Breadcrumb 一致：主页 + 各级 meta.title
 */
function getOperationRouteContext(route) {
  var r = route || _router && _router.currentRoute;
  if (!r) {
    return {
      opration_path: '',
      operation_menu: ''
    };
  }
  var matched = (r.matched || []).filter(function (item) {
    return item.meta && item.meta.title;
  });
  var first = matched[0];
  var isHome = first && first.name && String(first.name).toLowerCase() === 'home';
  if (matched.length && !isHome) {
    matched = [{
      path: '/home',
      meta: {
        title: '主页'
      }
    }].concat(matched);
  }
  var titles = matched.filter(function (item) {
    return item.meta && item.meta.title && item.meta.breadcrumb !== false;
  }).map(function (item) {
    return item.meta.title;
  });
  return {
    opration_path: r.fullPath || r.path || '',
    operation_menu: titles.join('/') || r.meta && r.meta.title || ''
  };
}
function buildDefaultContent(config) {
  var url = config.url || '';
  var method = (config.method || 'post').toUpperCase();
  var body = formatPayloadForContent(config.data);
  var action = inferActionLabel(url);
  if (body) return "".concat(action, "\uFF1A").concat(body);
  return "".concat(action, "\uFF1A").concat(String(url).split('?')[0]);
}

/**
 * 从请求配置推断埋点（未显式传入 reportMeta 时使用）
 */
function inferReportMetaFromRequest(config) {
  var ctx = getOperationRouteContext();
  var url = config.url || '';
  var method = (config.method || 'post').toLowerCase();
  return {
    operation_source: OPERATION_SOURCE_PC,
    opration_path: ctx.opration_path,
    operation_menu: ctx.operation_menu,
    operation_option: inferOptionName(url, method),
    content: buildDefaultContent(config)
  };
}

/**
 * 上报操作埋点（静默失败，不影响主流程）
 * @param {Object} meta operation_option、content 必填；opration_path、operation_menu 可省略（自动取当前路由）
 */
/**
 * 【操作埋点】2026-05-25 统一上报入口（静默失败）
 */
function reportAdminOperation() {
  var meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var operationId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (!meta.operation_option && !meta.content) return Promise.resolve();

  // 验证埋点ID是否在白名单中
  var checkId = operationId || meta.operation_id;
  if (checkId && !isInWhitelist(checkId)) {
    console.warn("[\u57CB\u70B9\u4E0A\u62A5] \u57CB\u70B9ID \"".concat(checkId, "\" \u4E0D\u5728\u767D\u540D\u5355\u4E2D\uFF0C\u5DF2\u8DF3\u8FC7\u4E0A\u62A5"));
    return Promise.resolve();
  }
  var ctx = getOperationRouteContext();
  var token = (0, _auth.getToken)() || '';
  var payload = {
    operation_source: OPERATION_SOURCE_PC,
    opration_path: meta.opration_path != null ? meta.opration_path : ctx.opration_path,
    operation_menu: meta.operation_menu != null ? meta.operation_menu : ctx.operation_menu,
    operation_option: meta.operation_option || '操作',
    content: meta.content || '',
    operation_id: checkId || ''
  };
  var qs = '?token=' + encodeURIComponent(token);
  // 使用原生 axios 实例，完全绕过 request.js 的拦截器逻辑
  return _axios.default.post(_vue.default.prototype.BASE_URL + REPORT_PATH + qs, _objectSpread(_objectSpread({}, payload), {}, {
    token: token,
    user_id: (0, _auth.getToken)('user_id'),
    agent_id: (0, _auth.getToken)('agent_id')
  })).then(function (res) {
    console.log('[埋点上报成功]', payload);
    return res;
  }).catch(function (err) {
    console.warn('[埋点上报失败]', payload, err);
  });
}

/**
 * 【操作埋点】2026-05-25 请求成功后触发上报（request.js 拦截器调用）
 * 需显式传入 operation_id（第三参数或 adminOperationReport），否则跳过
 */
function triggerAdminOperationReportAfterSuccess(response) {
  var config = response && response.config;
  if (!config || config.skipAdminOperationReport) return;
  var method = (config.method || '').toLowerCase();
  var url = config.url || '';
  if (method === 'get') return;
  if (shouldSkipReportUrl(url)) return;
  if (method === 'post' && !isMutationPostUrl(url) && !config.adminOperationReport) return;
  var explicit = config.adminOperationReport;
  var payload = explicit ? {
    operation_option: explicit.operation_option,
    content: explicit.content,
    opration_path: explicit.opration_path,
    operation_menu: explicit.operation_menu,
    operation_id: explicit.operation_id
  } : inferReportMetaFromRequest(config);

  // 如果没有显式配置 operation_id，且自动推断也没有，则不上报
  var operationId = explicit ? explicit.operation_id : undefined;
  if (!operationId) {
    console.log('[埋点上报] 缺少 operation_id，已跳过上报', url);
    return;
  }
  reportAdminOperation(payload, operationId);
}

/**
 * 包装已有 Promise，在成功后上报（页面内显式调用）
 * @param {Promise} promise
 * @param {{ operation_option: string, content: string, opration_path?: string, operation_menu?: string }} reportMeta
 */
function withAdminOperationReport(promise, reportMeta) {
  return promise.then(function (res) {
    if (reportMeta && reportMeta.operation_option) {
      reportAdminOperation(reportMeta, reportMeta.operation_id);
    }
    return res;
  });
}

/**
 * 【操作埋点】2026-05-25 构造 $post / $put / $delete 第三个参数用的埋点对象
 */
function buildAdminOperationReportMeta(_ref) {
  var operation_option = _ref.operation_option,
    content = _ref.content,
    opration_path = _ref.opration_path,
    operation_menu = _ref.operation_menu,
    operation_id = _ref.operation_id;
  var ctx = getOperationRouteContext();
  return {
    operation_option: operation_option,
    content: content,
    opration_path: opration_path != null ? opration_path : ctx.opration_path,
    operation_menu: operation_menu != null ? operation_menu : ctx.operation_menu,
    operation_id: operation_id || ''
  };
}

/**
 * 【操作埋点】2026-05-25 解析 $post/$put/$delete 第三参数（false 表示跳过上报）
 */
function normalizeReportMetaOption(thirdArg) {
  if (thirdArg === false || thirdArg === null) {
    return {
      skipAdminOperationReport: true
    };
  }
  if (thirdArg && (0, _typeof2.default)(thirdArg) === 'object' && thirdArg.operation_option) {
    return {
      adminOperationReport: thirdArg
    };
  }
  return {};
}

/**
 * 批量标记操作日志为已通知
 * @param {Array|String} ids - 操作日志ID数组或逗号分隔的字符串
 * @returns {Promise}
 */
function batchMarkOperationNotified(ids) {
  var token = (0, _auth.getToken)() || '';
  var userId = (0, _auth.getToken)('user_id') || '';
  var agentId = (0, _auth.getToken)('agent_id') || '';

  // 如果传入的是数组，转换为逗号分隔的字符串
  var idsStr = Array.isArray(ids) ? ids.join(',') : ids;
  if (!idsStr) {
    console.warn('[批量标记] IDs 为空，跳过请求');
    return Promise.resolve();
  }

  // 使用 FormData 格式发送
  var formData = new FormData();
  formData.append('ids', idsStr);
  var qs = '?token=' + encodeURIComponent(token) + '&user_id=' + encodeURIComponent(userId) + '&agent_id=' + encodeURIComponent(agentId);
  console.log('[批量标记] 开始标记操作日志为已通知，IDs:', idsStr);
  return _axios.default.post(_vue.default.prototype.BASE_URL + '/agentapi/admin_operation/batch_mark_notified' + qs, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }).then(function (res) {
    console.log('[批量标记] 标记成功', res);
    return res;
  }).catch(function (err) {
    console.warn('[批量标记] 标记失败', err);
    // 静默失败，不影响主流程
    return Promise.resolve();
  });
}